import React from 'react';
import { UniversalEditorContext } from '../context/universal-editor-context';
import { createUniversalEditorFilterId, createUniversalEditorResource, validateUeData, } from '../utils';
export const UeElement = ({ type, resource, behavior, label, filter, property, model, children, isAuthorMode, as, }) => {
    const ueContext = React.useContext(UniversalEditorContext);
    const authorMode = isAuthorMode !== null && isAuthorMode !== void 0 ? isAuthorMode : (ueContext.isAuthorMode && ueContext.isFalconContent);
    let AsElement = 'span';
    if (!as && type === 'container') {
        AsElement = 'div';
    }
    else if (as) {
        AsElement = as;
    }
    const ueProps = {
        'data-aue-type': type,
        'data-aue-resource': resource && createUniversalEditorResource(resource),
        'data-aue-label': label,
        'data-aue-behavior': behavior,
        'data-aue-prop': property,
        'data-aue-filter': filter &&
            (typeof filter === 'string'
                ? filter
                : createUniversalEditorFilterId(filter.model, filter.field)),
        'data-aue-model': model,
    };
    React.useEffect(() => {
        if (authorMode) {
            validateUeData(ueProps);
        }
    }, []);
    if (typeof children === 'function') {
        return children(authorMode ? ueProps : undefined);
    }
    return React.createElement(AsElement, Object.assign({}, (authorMode && ueProps)), children);
};
//# sourceMappingURL=ue-element.js.map